import * as actionTypes from "./LoginTypes";

const INITIAL_STATE = {
  userName: "",
  password: "",
  isAuthenticated: false,
};

const LoginReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.USERNAME:
      return {
        ...state,
        userName: action.payload,
      };
    case actionTypes.PASSWORD:
      return {
        ...state,
        password: action.payload,
      };
    case actionTypes.LOGIN:
      return {
        userName: action.payload.userName,
        password: action.payload.password,
      };
    case actionTypes.AUTHENTICATED:
      return {
        isAuthenticated: action.payload.isAuthenticated,
      };
    case actionTypes.LOGOUT:
      return {
        userName: "",
        password: "",
        isAuthenticated: false,
      };
    default:
      return state;
  }
};

export default LoginReducer;
